import styled, { css } from 'styled-components';
import { multiplyPx } from '../styled/utils';
import Button from '../button';
import { breakpoint } from '../theme/breakpoint';
import { Container } from '../styled/containers';
import LinkButton from '../link-button';
import { generateBackgroundImages } from '../styled/background-image';
import { h2 } from '../styled/typography';
import DonationInput from '../form-elements/donation-input';

const halfPx = multiplyPx(0.5);

export const mobileHeroHeight = 200;
export const tabletHeroHeight = 300;
export const desktopHeroHeight = 650;

const imageSizes = {
  mobile: [null, mobileHeroHeight],
  tablet: [null, tabletHeroHeight],
  desktop: [null, desktopHeroHeight],
};

export const Hero = styled.section`
  position: relative;
  margin-bottom: ${({ theme }) => theme.spacing.large};
`;

export const ImageWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  display: ${({ $imageAboveOnMobile: imageAboveOnMobile }) =>
    imageAboveOnMobile ? 'block' : 'flex'};

  ${breakpoint.tablet`
    display: ${({ $imageAboveOnTablet: imageAboveOnTablet }) =>
      imageAboveOnTablet ? 'block' : 'flex'};
    `};
`;

export const Image = styled.div`
  min-height: ${mobileHeroHeight}px;
  max-height: ${mobileHeroHeight}px;
  height: 100%;
  background-position: center;
  background-size: cover;
  ${({ $image: image }) =>
    image && generateBackgroundImages({ image, imageSizes, size: 'mobile' })};
  order: 2;

  ${breakpoint.tablet`
    min-height: ${tabletHeroHeight}px;
    max-height: ${tabletHeroHeight}px;
    ${({ $image: image }) =>
      image && generateBackgroundImages({ image, imageSizes, size: 'tablet' })};
  `};

  ${breakpoint.desktop`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    max-height: none;
    ${({ $image: image }) =>
      image &&
      generateBackgroundImages({ image, imageSizes, size: 'desktop' })};
  `}
`;

export const InputBox = styled.div`
  background: ${({ theme }) => theme.palette.white};
  position: relative;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.standard};

  ${breakpoint.desktop`
    margin-top: ${({ theme }) => theme.spacing.xlarge};
    margin-bottom: ${({ theme }) => theme.spacing.xlarge};
    width: 60%;
  `}
`;

export const DonateWrapper = styled.section`
  padding: ${({ theme }) =>
    `${theme.spacing.medium} ${theme.spacing.standard} ${theme.spacing.standard}`};
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const StyledButton = styled(Button)`
  display: inline-block;
  flex: 1;
  &:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacing.standard};
  }
`;

export const Title = styled.h1`
  ${h2};
  margin-bottom: ${({ theme }) => theme.spacing.large};
  margin-top: 0;
`;

export const Description = styled.p`
  ${breakpoint.desktop`
    min-height: 3em;
  `}
`;

export const StyledContainer = styled(Container)`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0;

  ${breakpoint.desktop`
    padding: 0 ${({ $padding, theme }) =>
      $padding === false ? 0 : theme.spacing.standard};
  `}
`;

export const OwnAmountField = styled(DonationInput)`
  max-width: 100%;
  display: inline-block;
  ${({ $error, theme }) =>
    $error &&
    css`
      border: 4px solid ${theme.palette.errorBorder};
      background-color: ${theme.palette.errorBackground};

      &:focus,
      &:active {
        background-color: ${theme.palette.white};
      }
    `}
`;

export const OwnAmountButton = styled(LinkButton)`
  display: block;
`;

export const DonateSubmit = styled(Button)`
  margin-top: ${({ theme }) => halfPx(theme.spacing.large)};
  width: 100%;
`;

export const OwnAmountSubmit = styled(Button)`
  margin-left: ${({ theme }) => halfPx(theme.spacing.tiny)};
`;

export const StyledLabel = styled.label`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;
